import { z } from 'zod';

export const MAINTENANCE_DEVICE_PROOF_HEADER = 'x-playcast-maintenance-proof';
export const MAINTENANCE_DEVICE_PROOF_DOMAIN = 'playcast-maintenance-device:v1';

export const maintenanceDeviceProofSchema = z.object({
  nonce: z.string().regex(/^[a-f0-9]{64}$/),
  signature: z.string().min(1).max(256),
}).strict();

export type MaintenanceDeviceProof = z.infer<typeof maintenanceDeviceProofSchema>;

/** Exact request-bound bytes signed by the enrolled machine key. */
export function maintenanceDeviceProofPayload(
  machineId: string,
  nonce: string,
  method: string,
  pathname: string,
  bodySha256: string,
): string {
  if (machineId.length < 1 || machineId.length > 256) throw new Error('maintenance_machine_id_invalid');
  if (!/^[a-f0-9]{64}$/.test(nonce)) throw new Error('maintenance_nonce_invalid');
  if (!/^[A-Z]+$/.test(method)) throw new Error('maintenance_method_invalid');
  if (!pathname.startsWith('/') || pathname.includes('?') || pathname.includes('#')) {
    throw new Error('maintenance_path_invalid');
  }
  if (!/^[a-f0-9]{64}$/.test(bodySha256)) throw new Error('maintenance_body_hash_invalid');
  return JSON.stringify([
    MAINTENANCE_DEVICE_PROOF_DOMAIN,
    machineId,
    nonce,
    method,
    pathname,
    bodySha256,
  ]);
}
